import {useEffect, useState} from "react";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";
import {UsersMinimalSchema, UserWithRoleSchema} from "@feature/types";
import apiRequest from "@services/apiRequest";

export const useHomeUsers = (country: string) => {

  // hooks
  const countryApiRequest = useCountryAxiosInstance();

  // state
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<UsersMinimalSchema[]>();

  // handlers
  const fetch = async () => {
    setLoading(true);
    try {
      const [connections, shared] = await Promise.all([
        countryApiRequest!.get("/worksites_sharing/sharers") as unknown as Promise<UsersMinimalSchema[]>,
        apiRequest.get(`/connections/bidirectional/${country}`) as unknown as Promise<UsersMinimalSchema[]>,
      ]);
      return Object.values([...connections, ...shared].reduce(
        (acc, user) => {
          acc[user.id] = user;
          return acc;
        },
        {} as Record<number, UsersMinimalSchema>
      )) as UsersMinimalSchema[];
    }
    finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    // On initial load and on filters change, we need to (re)fetch the pins
    fetch().then(setData);
  }, []);

  return {loading, data};
}